import React, { useState } from "react";
import { Outlet } from "react-router-dom";
import { Sidebar } from "./Sidebar";
import { TopBar } from "./TopBar";
import { DemoReadOnlyBanner } from "@/components/demo/DemoUi";

export const AppLayout = () => {
  const [collapsed, setCollapsed] = useState(false);

  return (
    <div className="min-h-screen bg-app-grid">
      <Sidebar
        collapsed={collapsed}
        onToggle={() => setCollapsed(true)}
        onExpand={() => setCollapsed(false)}
      />
      <div className={`transition-[padding] duration-300 ${collapsed ? "lg:pl-[104px]" : "lg:pl-[284px]"}`}>
        <TopBar />
        <main className="mx-auto max-w-7xl px-4 py-6 sm:px-6 lg:px-10 lg:py-8">
          <DemoReadOnlyBanner />
          <Outlet />
        </main>
      </div>
    </div>
  );
};
